module.exports = __webpack_public_path__ + "img/pc_intr.16b6aca.jpg";